"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("../TextField/constant");
var _constant3 = require("./constant");
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    theme: _propTypes.string,
    onChange: _propTypes.func,
    onBlur: _propTypes.func,
    onFocus: _propTypes.func,
    dateFormat: _propTypes.string,
    validateStatus: (0, _propTypes.oneOf)([_constant2.VALIDATE_STATUS_SUCCESS, _constant2.VALIDATE_STATUS_ERROR, _constant2.VALIDATE_STATUS_WARNING]),
    validateMessage: _propTypes.string,
    validateIcon: _propTypes.string,
    value: _propTypes.string,
    icon: _propTypes.string,
    onIconClick: _propTypes.func,
    isMobile: _propTypes.bool,
    placeholder: _propTypes.string,
    label: _propTypes.string,
    className: _propTypes.string,
    disabled: _propTypes.bool,
    labelMarginBottomLarge: _propTypes.bool,
    alignContentRight: _propTypes.bool,
    borderRadius: _propTypes.string,
    containerBoxSizing: _propTypes.string,
    enableFontSizeChange: _propTypes.bool,
    disclaimer: (0, _propTypes.shape)({
      title: _propTypes.string,
      text: _propTypes.string
    }),
    showIcon: _propTypes.bool,
    disclaimerModal: _propTypes.bool,
    dateObj: _propTypes.object
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    dateFormat: _constant3.DEFAULT_DATE_INPUT_FORMAT,
    isMobile: false,
    labelMarginBottomLarge: false,
    alignContentRight: false,
    onIconClick: undefined,
    icon: undefined,
    enableFontSizeChange: false,
    showIcon: true,
    disclaimerModal: false
  }
};
exports.default = _default;